import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../features/app-setting/redux/actions';
import { createAllPath } from '../../../common/utils/api_utils';
import { RouteConfig } from '..';

export class CollectionRouteConfig extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    routes: [],
  };

  componentDidMount = () => {
    const { collection, appSetting } = this.props;
    if (collection) {
      const { emailTemplate, projectDevApis } = appSetting;
      const paths = createAllPath(collection, emailTemplate, projectDevApis);
      this.setState({ routes: paths });
    }
    return true;
  };

  renderRoutes = () => {
    const { routes } = this.state;
    const { collection, appSetting, projectId, version, enableEncryption } = this.props;
    let { allPermissions, userRoles } = appSetting;
    const { collectionName } = collection;
    return (
      <>
        {routes.map((route) => (
          <RouteConfig
            key={route.uniqueKey}
            projectId={projectId}
            version={version}
            enableEncryption={enableEncryption}
            route={route}
            allPermissions={allPermissions}
            userRoles={userRoles}
          />
        ))}
      </>
    );
  };

  render() {
    const { collection } = this.props;
    if (!collection) {
      return '';
    }

    return <div className="app-setting-collection-route-config">{this.renderRoutes()}</div>;
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionRouteConfig);
